// Export all follow-up accounts functions
export {
  getFollowUpAccounts,
  getFollowUpAccountById,
  createFollowUpAccount,
  updateFollowUpAccount,
  updateFollowUpAccountById,
  deleteFollowUpAccount,
  bulkCreateFollowUpAccounts,
  bulkUpdateFollowUpAccounts,
  updateAccountStatus,
  recordFollowUpActivity,
  getFollowUpStats,
  aggregateFollowUpAccounts,
  deleteAllFollowUpAccounts,
  countFollowUpAccounts
} from './followUpAccounts'

// Export all compensation claims functions
export {
  getCompensationClaims,
  getCompensationClaimById,
  createCompensationClaim,
  updateCompensationClaim,
  deleteCompensationClaim,
  updateClaimStatus,
  addClaimDocument,
  getClaimsStatsByType,
  countCompensationClaims,
  aggregateCompensationClaims,
  deleteAllCompensationClaims
} from './compensationClaims'

// Export all patient ledger functions
export {
  getPatientLedgerTransactions,
  getPatientLedgerSummary,
  createLedgerTransaction,
  recordPayment,
  recordAdjustment,
  recordWriteOff,
  getTransactionHistory,
  getPatientStatement,
  recordRefund,
  recordRemittancePayment,
  recordCredit,
  recordDebit,
  deleteAllPatientLedgerTransactions
} from './patientLedger'

// Export all follow-up history functions
export {
  getFollowUpHistory,
  createFollowUpHistory,
  recordPhoneCall,
  recordEmail,
  recordSMS,
  recordWhatsApp,
  recordStatusChange,
  getActivitySummary,
  deleteFollowUpHistory,
  deleteAllFollowUpHistory
} from './followUpHistory'

export * from './creditNotes'
export * from './paymentAllocation'

// Export billing integration functions separately to avoid conflicts
export {
  processInvoiceCreation,
  processPatientPayment,
  processMedicalAidRemittance,
  processRefund as processRefundTransaction,
  processCreditNote,
  getComprehensiveBalance
} from './billingIntegration'

// Temporary stub for account notes deletion
export const deleteAllAccountNotes = () => {
  return Promise.resolve({ success: true, message: 'Account notes deletion not implemented yet' })
}
